module.exports = __webpack_public_path__ + "img/y-s.2121032e.png";